module.exports = __webpack_public_path__ + "img/16.3a1f1a2a.jpg";